$(() => {
  const pathname = $(location).attr("href").split('/');
  const page = pathname[pathname.length - 2];

  if(page === "heritage" || page === "herencia"){
    $("article.callout--heritage").addClass("active");
    $("article.callout").on("mouseenter", function(){
      $(this).addClass("active");
    })
    $("article.callout").on("mouseleave", function(){
      if(!$(this).hasClass("callout--heritage")){
        $(this).removeClass("active");
      }
    })
    $("article.callout").next().on("mouseenter", function(){
      $(this).prev().addClass("active");
    })
    $("article.callout").next().on("mouseleave", function(){
      if(!$(this).prev().hasClass("callout--heritage")){
        $(this).prev().removeClass("active");
      }
    })
  } else if (page === "sustainability" || page === "sostenibilidad"){
    $("article.callout--sustainability").addClass("active");
    $("article.callout").on("mouseenter", function(){
      $(this).addClass("active");
    })
    $("article.callout").on("mouseleave", function(){
      if(!$(this).hasClass("callout--sustainability")){
        $(this).removeClass("active");
      }
    })
    $("article.callout").next().on("mouseenter", function(){
      $(this).prev().addClass("active");
    })
    $("article.callout").next().on("mouseleave", function(){
      if(!$(this).prev().hasClass("callout--heritage")){
        $(this).prev().removeClass("active");
      }
    })
  } else if (page === "quality" || page === "calidad"){
    $("article.callout--quality").addClass("active");
    $("article.callout").on("mouseenter", function(){
      $(this).addClass("active");
    })
    $("article.callout").on("mouseleave", function(){
      if(!$(this).hasClass("callout--quality")){
        $(this).removeClass("active");
      }
    })
    $("article.callout").next().on("mouseenter", function(){
      $(this).prev().addClass("active");
    })
    $("article.callout").next().on("mouseleave", function(){
      if(!$(this).prev().hasClass("callout--heritage")){
        $(this).prev().removeClass("active");
      }
    })
  }
});
